var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.quickAds.length
    ? _c(
        "v-carousel",
        {
          attrs: {
            "delimiter-icon": "stop",
            "hide-delimiters": "",
            cycle: "",
            height: "180px",
            "show-arrows-on-hover": "",
            "hide-delimiter-background": "",
            "next-icon": "fad fa-chevron-right",
            "prev-icon": "fad fa-chevron-left",
            "aria-label": "Promotional banner carousel",
            role: "region",
          },
        },
        _vm._l(_vm.quickAds, function (item) {
          return _c(
            "v-carousel-item",
            {
              key: item.id,
              staticClass: "landing-carsoul-item",
              attrs: {
                value: item.title,
                src: item.imageSrc,
                ripple: true,
                role: "button",
                tabindex: "0",
                "aria-label": item.title + ": " + item.subtitle,
              },
              on: {
                click: function ($event) {
                  return _vm.goTo(item.link)
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.goTo(item.link)
                },
              },
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "landing-carsoul-content",
                  attrs: {
                    column: "",
                    "align-center": "",
                    "justify-center": "",
                  },
                },
                [
                  _c("div", {
                    staticClass: "landing-carsoul-content-title",
                    attrs: { role: "heading", "aria-level": "2" },
                    domProps: { innerHTML: _vm._s(item.title) },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "landing-carsoul-content-date",
                      attrs: { role: "text" },
                    },
                    [_vm._v("\n        " + _vm._s(item.subtitle) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(item.title) +
                        " - " +
                        _vm._s(item.subtitle) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-divider", {
                    attrs: { role: "presentation", "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("v-layout", {
                    staticClass: "landing-carsoul-content-btns",
                    attrs: { "align-center": "", role: "presentation" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }